import type { AppKey, Locale } from '@iac/contracts';
import type { Dictionary } from './dictionary';

/** Header, launcher, profile, login and landing — the screens outside any app. */
const pl = {
  /** Toggle tooltip, keyed by the language a click switches to. */
  switchTo: {
    pl: 'Przełącz na polski',
    en: 'Przełącz na angielski',
  } as Record<Locale, string>,
  /** Disabled-toggle hint, keyed by the one language the app has. */
  onlyIn: {
    pl: 'Ta aplikacja jest dostępna tylko po polsku',
    en: 'Ta aplikacja jest dostępna tylko po angielsku',
  } as Record<Locale, string>,
  profile: 'Profil',
  signOut: 'Wyloguj',
  appMenu: 'Menu aplikacji',
  dismiss: 'Zamknij',

  landingSubtitle: 'Aplikacje webowe',

  signInPrompt: 'Zaloguj się, aby kontynuować.',
  login: 'Login',
  password: 'Hasło',
  signIn: 'Zaloguj',
  signInFailed: 'Nieprawidłowy login lub hasło.',

  apps: 'Aplikacje',
  noApps: 'Nie masz jeszcze dostępu do żadnej aplikacji.',
  appNames: {
    admin: 'Panel administracyjny',
    library: 'Biblioteka',
    ag5: 'AG5',
    finances: 'Finanse',
    brain: 'Brain',
    calories: 'Kalorie',
    boxer: 'Boxer',
    recipes: 'Przepisy',
    checklists: 'Checklisty',
  } as Record<AppKey, string>,

  account: 'Konto',
  signedInAs: 'Zalogowano jako',
  changePassword: 'Zmiana hasła',
  currentPassword: 'Obecne hasło',
  newPassword: 'Nowe hasło',
  confirmNewPassword: 'Powtórz nowe hasło',
  updatePassword: 'Zmień hasło',
  passwordUpdated: 'Hasło zostało zmienione.',
  passwordChangeFailed: 'Nie udało się zmienić hasła.',

  notFoundTitle: 'Nie znaleziono strony',
  notFoundBody: 'Strona, której szukasz, nie istnieje.',
  backToApps: 'Wróć do aplikacji',
};

const en: typeof pl = {
  switchTo: { pl: 'Switch to Polish', en: 'Switch to English' },
  onlyIn: {
    pl: 'This app is available in Polish only',
    en: 'This app is available in English only',
  },
  profile: 'Profile',
  signOut: 'Sign out',
  appMenu: 'App menu',
  dismiss: 'Dismiss',

  landingSubtitle: 'Web Applications',

  signInPrompt: 'Sign in to continue.',
  login: 'Login',
  password: 'Password',
  signIn: 'Sign in',
  signInFailed: 'Invalid login or password.',

  apps: 'Applications',
  noApps: "You don't have access to any applications yet.",
  appNames: {
    admin: 'Admin panel',
    library: 'Library',
    ag5: 'AG5',
    finances: 'Finances',
    brain: 'Brain',
    calories: 'Calories',
    boxer: 'Boxer',
    recipes: 'Recipes',
    checklists: 'Checklists',
  },

  account: 'Account',
  signedInAs: 'Signed in as',
  changePassword: 'Change password',
  currentPassword: 'Current password',
  newPassword: 'New password',
  confirmNewPassword: 'Confirm new password',
  updatePassword: 'Update password',
  passwordUpdated: 'Password updated.',
  passwordChangeFailed: 'Could not change the password.',

  notFoundTitle: 'Page not found',
  notFoundBody: "The page you're looking for doesn't exist.",
  backToApps: 'Back to applications',
};

export const shell: Dictionary<typeof pl> = { pl, en };
